import { render, staticRenderFns } from "./authEmpty.vue?vue&type=template&id=7c2fce28&scoped=true&"
import script from "./authEmpty.vue?vue&type=script&lang=js&"
export * from "./authEmpty.vue?vue&type=script&lang=js&"
import style0 from "./authEmpty.vue?vue&type=style&index=0&id=7c2fce28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2fce28",
  null
  
)

export default component.exports